module.exports = __webpack_public_path__ + "static/media/curs.80c9ce70.svg";